import React, { Component } from "react";
import PropTypes from "prop-types";

import deviceServices from "services/deviceServices";

const propTypes = {
  sessionKey: PropTypes.string,
  challengeId: PropTypes.number.isRequired,
  claimed: PropTypes.bool,
  externalEmbeddable: PropTypes.object
};

class ExternalChallenge extends Component {
  render() {
    let displayUrl = this.props.externalEmbeddable
      ? this.props.externalEmbeddable.displayUrl
      : "";
    let url = this.props.externalEmbeddable
      ? this.props.externalEmbeddable.url
      : "";

    return (
      <div
        className={
          "iframe-container-external-challenge" +
          (deviceServices.isIOS() ? " iframe-scroll-wrapper" : "")
        }
      >
        <iframe
          title={displayUrl}
          ref="externalChallengeIframe"
          src={
            url +
            "?session_key=" +
            this.props.sessionKey +
            "&challenge_id=" +
            this.props.challengeId +
            "&hasClaimed=" +
            this.props.claimed
          }
        />
      </div>
    );
  }
}

ExternalChallenge.propTypes = propTypes;

export default ExternalChallenge;
